import {Pipe, PipeTransform} from '@angular/core';
// import * as moment from 'moment';

@Pipe({
  name: 'timeStampPipe'
})
export class TimeStampPipe implements PipeTransform {

  transform(value: any, format?: string): any {
    const date = new Date(value);
    const today = new Date();
   /* if (date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear()) {
      return format === 'notification' ? 'Today at ' + moment(date).format('hh:mm') : 'today';
    } else if ((date.getDate() === (today.getDate() + 1)) && (date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear())) {
      return 'tomorrow';
    } else {
      return moment(date).format('dddd DD/MM/yyyy')
    }*/
  }
}
